import { inject } from '@angular/core';

import { ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Action, Store } from '@ngrx/store';
import { OperatorFunction, filter, map, pipe } from 'rxjs';

import BetslipPickActions from './actions';
import { selectBetslipFlattenedPicksList } from './selectors';

export function ofTypeReplaceExistingPick<T extends Action>(): OperatorFunction<T, ReturnType<typeof BetslipPickActions.replacePick>> {
    return pipe(ofType(BetslipPickActions.replacePick), ensurePickExistsOnReplace());
}

export function ensurePickExistsOnReplace(): OperatorFunction<
    ReturnType<typeof BetslipPickActions.replacePick>,
    ReturnType<typeof BetslipPickActions.replacePick>
> {
    const store = inject(Store);

    return pipe(
        concatLatestFrom(() => store.select(selectBetslipFlattenedPicksList)),
        filter(([action, pickList]) => pickList.some((p) => p.id.isEqual(action.newPick.id))),
        map(([action]) => action),
    );
}
